import { createReducer, on } from "@ngrx/store";
import { AchActions, CheckActions, InternalTransferActions, WireActions } from "../actions";
import { TrustInfo } from "../models/trust/TrustInfo";

export const trustInfoKey = 'trustInfo';

export interface State extends TrustInfo { };

export const initialTrustInfoState: TrustInfo = {
  trustTaxCategoriesAndCodes: {}
}

export const reducer = createReducer(
  initialTrustInfoState,
  on(InternalTransferActions.loadToAccountSuccess, (state, response) => {
    return {
      ...state,
      trustTaxCategoriesAndCodes: response.internalTransferInputResponse.taxCodeList
    }
  }),
  on(AchActions.inputCallSuccessful, (state, response) => {
    return {
      ...state,
      trustTaxCategoriesAndCodes: response.achInfo.trustTaxCategoriesAndCodes
    }
  }),
  on(WireActions.wireInputCallSuccessfulV3, WireActions.wireInputCallV3TemplateFlowSuccessful, (state, {response}) => {
    return {
      ...state,
      trustTaxCategoriesAndCodes: response.accountInfo?.trustInfo?.taxCodeList
    }
  }),
  on(CheckActions.inputCallSuccessful, (state, response) => {
    return {
      ...state,
      trustTaxCategoriesAndCodes: response?.checkInputResponse?.taxCodeList
    }
  }),
  on(CheckActions.inquiryCallSuccessful, (state, response) => {
    return {
      ...state,
      trustTaxCategoriesAndCodes: response?.checkInquiryResponse?.taxCodeList
    }
  }),
  on(InternalTransferActions.inquiryCallSuccessful, (state, response) => {
    return {
      ...state,
      trustTaxCategoriesAndCodes: response?.internalTransferInquiryResponse?.taxCodeList
    }
  })
)
